import {useAppUpdate} from '@features/AppUpdateProvider/AppUpdateProvider';
import {Dialog, DialogTitle, DialogContent, DialogActions, Button} from '@mui/material';

export const AppUpdateDialog = () => {
    const {update, apply} = useAppUpdate();

    return (
        <Dialog
            open={update}
            onClose={() => {}}
            fullWidth
            maxWidth='sm'
        >
            <DialogTitle>Доступна новая версия</DialogTitle>
            <DialogContent>Мы обновили приложение. Нажмите «Обновить».</DialogContent>
            <DialogActions
                sx={{
                    justifyContent: 'center',
                }}
            >
                <Button
                    variant='contained'
                    onClick={apply}
                    sx={{
                        width: '50%',
                    }}
                >
                    Обновить
                </Button>
            </DialogActions>
        </Dialog>
    );
};
